import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function Home() {
  const faq = [
    {
      q: "Hvor hurtigt må man køre med en almindelig trailer i Danmark?",
      a: "Hovedreglen er 80 km/t på både motorvej, motortrafikvej og landevej uden for tættere bebygget område. I byer gælder den lokale hastighedsgrænse, typisk 50 km/t. Kun med en særlig dansk Tempo 100-godkendelse må du køre 100 km/t på motorvej."
    },
    {
      q: "Hvor meget må man trække med et almindeligt B-kørekort?",
      a: "Med kategori B må du altid køre med en trailer på op til 750 kg tilladt totalvægt, uanset bilens vægt (så længe bilen må trække den). Hvis traileren har en totalvægt over 750 kg, må bilens tilladte totalvægt og trailerens tilladte totalvægt tilsammen højst være 3.500 kg."
    },
    {
      q: "Skal en almindelig havetrailer til periodisk syn?",
      a: "Nej. Almindelige påhængsvogne til personbiler indkaldes ikke automatisk til periodisk syn, medmindre de er godkendt til Tempo 100 og har en totalvægt over 750 kg. Ved ejerskifte gælder der særlige synsfrister afhængigt af trailerens alder."
    }
  ];

  return (
    <>
      <SEO 
        title="Trailerregler i Danmark — Guide til kørekort og vægt" 
        description="Få overblik over trailerregler i Danmark: kørekort (B, B+, BE), vægtgrænser, hastighed, synsfrister, lygter og registrering." 
        pathname="/"
        faq={faq}
        isHome={true}
      />

      <article>
        <h1 className="text-[32px] sm:text-[38px] font-bold text-[#2E3A46] tracking-tight leading-tight mb-4">
          Trailerregler i Danmark
        </h1>

        <p className="text-[18px] text-[#5C636B] leading-relaxed mb-8">
          En uafhængig og faktuel opslagsguide til de gældende færdselsregler for kørsel med trailer. Svarene bygger direkte på regler og bekendtgørelser fra Færdselsstyrelsen, Retsinformation og Motorstyrelsen.
        </p>

        {/* Hurtige genveje til nøglesider */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-10">
          <Link 
            to="/koerekort-og-trailer" 
            className="p-4 border border-[#E4E1D8] bg-[#FBFAF6] hover:bg-[#FBF3DA] hover:border-[#B58200] rounded-[4px] transition-all group"
          >
            <span className="block text-[13px] font-mono uppercase tracking-wider text-[#B58200] font-semibold mb-1">
              Kørekort
            </span>
            <span className="text-[16px] font-bold text-[#2E3A46] group-hover:underline">
              B, B+ og BE regler
            </span>
          </Link>
          <Link 
            to="/hvor-meget-maa-man-traekke" 
            className="p-4 border border-[#E4E1D8] bg-[#FBFAF6] hover:bg-[#FBF3DA] hover:border-[#B58200] rounded-[4px] transition-all group"
          >
            <span className="block text-[13px] font-mono uppercase tracking-wider text-[#B58200] font-semibold mb-1">
              Vægtgrænser
            </span>
            <span className="text-[16px] font-bold text-[#2E3A46] group-hover:underline">
              Hvor meget må du trække?
            </span>
          </Link>
          <Link 
            to="/trailer-hastighed" 
            className="p-4 border border-[#E4E1D8] bg-[#FBFAF6] hover:bg-[#FBF3DA] hover:border-[#B58200] rounded-[4px] transition-all group"
          >
            <span className="block text-[13px] font-mono uppercase tracking-wider text-[#B58200] font-semibold mb-1">
              Fart
            </span>
            <span className="text-[16px] font-bold text-[#2E3A46] group-hover:underline">
              Hastighed &amp; motorvej
            </span>
          </Link>
        </div>

        {/* De tre klynger */}
        <div className="space-y-12">
          {/* Klynge A */}
          <section className="pt-6 border-t border-[#E4E1D8]">
            <h2 className="text-[22px] font-bold text-[#2E3A46] mb-3">
              Kørekort og vægt
            </h2>
            <p className="text-[15px] text-[#5C636B] mb-4">
              Regler for hvad dit kørekort tillader, beregning af tilladt totalvægt, kugletryk og trailerstørrelser.
            </p>
            <ul className="space-y-2.5 list-none p-0 m-0 text-[16px]">
              <li>
                <Link to="/trailer-regler" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Trailerregler i Danmark: Det samlede overblik
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Hvad der gælder ved kørsel med påhængskøretøj på danske veje.</span>
              </li>
              <li>
                <Link to="/koerekort-og-trailer" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Kørekort og trailer: B, B+ og BE
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Regler for kategori B, B+ og BE samt betydningen af udstedelsesdato.</span>
              </li>
              <li>
                <Link to="/hvor-meget-maa-man-traekke" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Hvor meget må man trække med almindeligt kørekort?
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Forskellen på kørsel med og uden trailerkørekort.</span>
              </li>
              <li>
                <Link to="/trailer-totalvaegt" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Totalvægt, egenvægt og lasteevne
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Sådan læses vægtskiltet, og hvad 750 kg-grænsen betyder.</span>
              </li>
              <li>
                <Link to="/be-koerekort" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Stort trailerkørekort (BE)
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Hvad kategorien giver ret til, omkostninger og prøveforløb.</span>
              </li>
              <li>
                <Link to="/kugletryk" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Kugletryk på trailer
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Korrekt læsning, bilens tilladte kugletryk og forebyggelse af slinger.</span>
              </li>
              <li>
                <Link to="/trailer-bremser" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Trailer med og uden bremser
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Påløbsbremse, sikkerhedswire og fejlfinding når bremser hænger.</span>
              </li>
              <li>
                <Link to="/trailer-laengde-og-bredde" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Maksimal længde, bredde og fremspringende last
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Målgrænser og krav til afmærkning af last der stikker ud.</span>
              </li>
            </ul>
          </section>

          {/* Klynge B */}
          <section className="pt-6 border-t border-[#E4E1D8]">
            <h2 className="text-[22px] font-bold text-[#2E3A46] mb-3">
              Hastighed og kørsel
            </h2>
            <p className="text-[15px] text-[#5C636B] mb-4">
              Hastighedsgrænser i Danmark og nabolandene, Tempo 100-ordningen og lovpligtig lastsikring.
            </p>
            <ul className="space-y-2.5 list-none p-0 m-0 text-[16px]">
              <li>
                <Link to="/trailer-hastighed" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Hastighed med trailer i Danmark
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Generelle grænser på landevej, motortrafikvej og motorvej.</span>
              </li>
              <li>
                <Link to="/tempo-100" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Tempo 100 for trailer
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Tekniske krav, godkendelse, syn og gyldighed i udlandet.</span>
              </li>
              <li>
                <Link to="/trailer-i-tyskland" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Kørsel med trailer i Tyskland
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Hastigheder, tysk Tempo 100 og søndagskørselsforbud.</span>
              </li>
              <li>
                <Link to="/trailer-i-sverige" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Kørsel med trailer i Sverige
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Hastighedsgrænser og de strenge svenske vinterdæksregler.</span>
              </li>
              <li>
                <Link to="/trailer-i-udlandet" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Kørsel med trailer i Norge, Frankrig og Europa
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Oversigt over europæiske hastigheder og påkrævede dokumenter.</span>
              </li>
              <li>
                <Link to="/lastsikring" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Lastsikring og surring
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Regler for fastspænding og valg af surringsbånd.</span>
              </li>
            </ul>
          </section>

          {/* Klynge C */}
          <section className="pt-6 border-t border-[#E4E1D8]">
            <h2 className="text-[22px] font-bold text-[#2E3A46] mb-3">
              Syn, nummerplade, lys, forsikring og dæk
            </h2>
            <p className="text-[15px] text-[#5C636B] mb-4">
              Praktiske regler om synsfrister, omregistrering, lygtekrav, forsikringsdækning og vægtafgift.
            </p>
            <ul className="space-y-2.5 list-none p-0 m-0 text-[16px]">
              <li>
                <Link to="/trailer-syn" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Syn af trailer: Frister og regler
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Hvornår skal en trailer synes, og hvad gælder ved ejerskifte?</span>
              </li>
              <li>
                <Link to="/trailer-nummerplade" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Nummerplade på trailer
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Bestilling, omregistrering, priser og nummerpladelygte.</span>
              </li>
              <li>
                <Link to="/trailer-lys-regler" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Regler for lygter og reflekser
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Lovpligtige lygter, trekantreflekser og 7-polet mod 13-polet stik.</span>
              </li>
              <li>
                <Link to="/trailer-forsikring" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Forsikring af trailer
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Bilens ansvarsforsikring, kasko og tyveridækning forklaret.</span>
              </li>
              <li>
                <Link to="/trailer-vaegtafgift" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Vægtafgift på trailere
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Grænsen på 500 kg, afgiftstrin og betalingsregler.</span>
              </li>
              <li>
                <Link to="/trailer-daek" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Trailerdæk: Dæktryk, alder og dimensioner
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Korrekt tryk, mønsterdybde og særlige krav til Tempo 100.</span>
              </li>
              <li>
                <Link to="/lille-trailer" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Lille trailer (350–500 kg)
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Særlige fordele ved ubremsede småtrailere under 500 kg.</span>
              </li>
              <li>
                <Link to="/ordbog" className="text-[#2E3A46] font-medium hover:text-[#B58200] hover:underline underline-offset-2">
                  Ordbog over trailerbegreber
                </Link>
                <span className="block text-[14px] text-[#5C636B]">Præcise definitioner af totalvægt, lasteevne, kugletryk og B+.</span>
              </li>
            </ul>
          </section>
        </div>

        <section className="mt-14 pt-8 border-t border-[#E4E1D8]">
          <h2 className="text-[20px] font-bold text-[#2E3A46] mb-4">
            Almindelige spørgsmål om trailerkørsel
          </h2>
          <div className="space-y-4">
            {faq.map((item, idx) => (
              <div key={idx} className="p-4 bg-[#FBF3DA] border border-[#E4E1D8] rounded-[4px]">
                <h3 className="text-[16px] font-bold text-[#2E3A46] mb-1">
                  {item.q}
                </h3>
                <p className="text-[15px] text-[#1A1C1F] m-0 leading-relaxed">
                  {item.a}
                </p>
              </div>
            ))}
          </div>
        </section>
      </article>
    </>
  );
}
